import React, { createContext, useContext, useEffect, useState } from 'react';
import CSRFService from '../services/csrfService';

const CSRFContext = createContext(null);

export const useCSRF = () => {
  const context = useContext(CSRFContext);
  if (!context) {
    throw new Error('useCSRF must be used within a CSRFProvider');
  }
  return context;
};

export const CSRFProvider = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeCSRF = async () => {
      try {
        // console.log('Initializing CSRF protection...');
        const token = await CSRFService.getToken();
        // console.log('CSRF initialized successfully');
        setIsInitialized(true);
      } catch (error) {
        console.error('CSRF initialization failed:', error);
        setError(error);
      }
    };

    initializeCSRF();
  }, []);

  // Don't render children until CSRF is initialized
  if (!isInitialized && !error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="mt-4 text-gray-600">Initializing security...</p>
        </div>
      </div>
    );
  }

  // If there's an error, you might want to handle it differently
  if (error) {
    console.warn('Proceeding without CSRF protection:', error);
  }

  return (
    <CSRFContext.Provider value={{ isInitialized, error }}>
      {children}
    </CSRFContext.Provider>
  );
};

export default CSRFProvider;